// extracted by mini-css-extract-plugin
export default {"section":"HeaderSection_section__bbIcL"};